import script from "./ListarPosvendas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarPosvendas.vue?vue&type=script&setup=true&lang=js"

import "./ListarPosvendas.vue?vue&type=style&index=0&id=e70d9592&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e70d9592"]])

export default __exports__